import { VOLUME_KEY } from '../../config/params';

function setVolumeToStorage(value) {
  localStorage.setItem(VOLUME_KEY, value);
}

export default setVolumeToStorage;
